import React from 'react';
import { isValidDate } from '@youhelp-ru/common/date';
import { useClientSubscription } from '@cp/entities/client/current/billing';
import { InvoiceStatus } from '@common/model/billing/payment/status';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useGetQueryParams, useUpdateQueryParams } from '@cp/shared/queryParams';
import { useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { useModal } from 'src/shared/modalProvider';
import { PAYMENT_SUCCESS_MODAL_NAME } from 'src/app/shared/components/modals/paymentSuccess/const';

export const useCheckPayments = () => {
  const { openModal } = useModal();
  const { pageId } = useClientWebRouteParams();
  const { data, isLoading: isLoadingClientSusbcription } = useClientSubscription();
  const queryParams = useGetQueryParams<{ checkPaymentsAfter?: string }>();
  const updateQueryParams = useUpdateQueryParams();

  React.useEffect(() => {
    const checkPaymentsAfter = 'checkPaymentsAfter' in queryParams ? queryParams.checkPaymentsAfter : undefined;

    if (checkPaymentsAfter === undefined) {
      return;
    }

    const checkAfterDate = new Date(checkPaymentsAfter);

    if (!isValidDate(checkAfterDate)) {
      updateQueryParams({ checkPaymentsAfter: undefined });
      return;
    }

    if (isLoadingClientSusbcription || !data) {
      return;
    }

    if (
      data.subscription.lastPayment?.updatedAt &&
      new Date(data.subscription.lastPayment?.updatedAt) > checkAfterDate &&
      data.subscription.lastPayment.status === InvoiceStatus.Approved
    ) {
      openModal(PAYMENT_SUCCESS_MODAL_NAME, {
        contentType: pageId === ClientWebPage.ProfileBilling ? 'catalogItemRelevantList' : undefined,
      });
    }

    updateQueryParams({ checkPaymentsAfter: undefined });
  }, [data, isLoadingClientSusbcription, openModal, pageId, queryParams, updateQueryParams]);
};
